export default __webpack_public_path__ + "static/media/CB_6192_tn.69d97906.jpg";